import { DocumentReference, DocumentSnapshot } from "firebase/firestore";
import Quiz from "../Communication/Quiz";
import Attachment from "../Filesystem/Attachment";
import { TrainingType } from "./TrainingType";
import SecureatSnapshot from "../SecureatSnapshot";

export default class TrainingCategory extends SecureatSnapshot {
    name: string;
    source: DocumentReference | null;
    type: TrainingType;

    constructor(ref: DocumentReference, name: string, source: DocumentReference, type: TrainingType) {

        super(ref);
        this.name = name;
        this.source = source;
        this.type = type;
    }

    public static fromFirestore(snapshot: DocumentSnapshot) {

        const data = snapshot.data()!;

        return new TrainingCategory(
            snapshot.ref,
            data.name,
            data.source,
            data.type
        );
    }
    toFirestore() {
        return {
            name: this.name,
            source: this.source,
            type: this.type,
        };
    }

}
